export default "__VITE_ASSET__bd1ec2ad__"